"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoRooms/Room/History/Desktop/SessionsList.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _Spinner = require('web/components/Spinner'); var _Spinner2 = _interopRequireDefault(_Spinner);





var _helpers = require('web/components/VideoRooms/Room/History/helpers');





var _utils = require('shared/utils');















const sessionsPerPage = 5

const buildHeaderColClassName = (x) => _classBuilder2.default.call(void 0, 'meeting--table-col', x)

const initialState = () => ({
  // SAFETY: timespanOptions is a non-empty module constant.
  currentTimespanOption: _helpers.timespanOptions[0].value,
  currentPage: 0,
  totalSessionsCount: 0,
  currentSessions: [],
  isLoading: false,
})

const calcPagesCount = (totalSessionsCount) =>
  Math.ceil(totalSessionsCount / sessionsPerPage)

// Handlers and setState callbacks read the committed props and state (`this`
// in the class) through refs, so loads chained after an update see it.
const DesktopHistoryList = (props) => {
  const latestProps = _react.useRef.call(void 0, props)
  _react.useLayoutEffect.call(void 0, () => { latestProps.current = props })

  const [state, setState, latestState] = _helpers.useClassState.call(void 0, initialState)

  const loadSessions = _react.useCallback.call(void 0, async () => {
    const { roomKey: RoomKey, loadSessionsList } = latestProps.current
    const { currentPage, currentTimespanOption } = latestState.current

    const StartedAfter = _helpers.calcStartedAfter.call(void 0, currentTimespanOption)

    setState({ isLoading: true })
    loadSessionsList({
      RoomKey,
      Skip: currentPage * sessionsPerPage,
      Take: sessionsPerPage,
      StartedAfter,
    }).then(response => {
      // SAFETY: deliberately unchecked, as in JS: a failed load resolves
      // undefined, this destructuring throws and the spinner stays on.
      const { RoomSessions, RoomSessionsCount } = response 
      setState({
        currentSessions: RoomSessions,
        totalSessionsCount: RoomSessionsCount,
        isLoading: false,
      })
    })
  }, [latestState, setState])

  // componentDidMount
  _react.useLayoutEffect.call(void 0, () => { loadSessions() }, [loadSessions])

  const handleTimespanChange = (e) =>
    setState({ currentTimespanOption: e.target.value }, loadSessions)

  const gotoPage = (idx) => {
    const pagesCount = calcPagesCount(latestState.current.totalSessionsCount)

    if (idx < 0 || idx >= pagesCount) return
    setState({ currentPage: idx }, loadSessions)
  }

  const gotoPrevPage = () => gotoPage(latestState.current.currentPage - 1)
  const gotoNextPage = () => gotoPage(latestState.current.currentPage + 1)

  const {
    currentTimespanOption,
    currentPage,
    isLoading,
    currentSessions,
    totalSessionsCount,
  } = state

  const renderTimespanPicker = () => (
    _react2.default.createElement('select', {
      value: currentTimespanOption,
      onChange: handleTimespanChange,
      className: "meeting--select meeting-room--history--timespan-select" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 104}}

      , 
        _helpers.timespanOptions.map(({ value, label }) => (
          _react2.default.createElement('option', { key: value, value: value, __self: this, __source: {fileName: _jsxFileName, lineNumber: 111}}
            ,  label 
          )
        ))
      
    )
  )

  if (totalSessionsCount === 0 && !isLoading) {
    return (
      _react2.default.createElement('div', { className: "meeting-room--history--header meeting-room--history--header--empty" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 121}}
        ,  renderTimespanPicker() 
        , _react2.default.createElement('h2', { className: "meeting-room--history--empty-warning", __self: this, __source: {fileName: _jsxFileName, lineNumber: 123}}, "No sessions" )
      )
    )
  }

  const { onSessionPick } = props
  const pagesCount = calcPagesCount(totalSessionsCount)
  const listedPagesCount = Math.min(pagesCount, 3)

  const pageMinIdx = Math.max(1, currentPage * sessionsPerPage)
  const pageMaxIdx = Math.min(
    currentPage * sessionsPerPage + sessionsPerPage,
    totalSessionsCount,
  )

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', { className: "meeting-room--history--header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 140}}
        ,  renderTimespanPicker() 
      )
      ,  isLoading
        ? _react2.default.createElement('div', { className: "meeting--table meeting-room--history--sessions-loader" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 144}}
            , _react2.default.createElement(_Spinner2.default, { color: "#6257c4", __self: this, __source: {fileName: _jsxFileName, lineNumber: 145}} )
          )
        : (
          _react2.default.createElement('div', { className: "meeting--table meeting-room--history--sessions-table" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 148}}
            , _react2.default.createElement('div', { className: "meeting--table-header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 149}}
              , _react2.default.createElement('div', { className: "meeting--table-row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 150}}
                , _react2.default.createElement('div', { className: buildHeaderColClassName("start-col"), __self: this, __source: {fileName: _jsxFileName, lineNumber: 151}}, "Started")
                , _react2.default.createElement('div', { className: buildHeaderColClassName("participants-col"), __self: this, __source: {fileName: _jsxFileName, lineNumber: 152}}, "Participants")
                , _react2.default.createElement('div', { className: buildHeaderColClassName("duration-col"), __self: this, __source: {fileName: _jsxFileName, lineNumber: 153}}, "Session Time" )
                , _react2.default.createElement('div', { className: buildHeaderColClassName("meeting--table-col more-col"), __self: this, __source: {fileName: _jsxFileName, lineNumber: 154}} )
              )
            )
            , _react2.default.createElement('div', { className: "meeting--table-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 157}}
              ,  currentSessions.map(s => {
                const { startedAt, duration } = _helpers.formatTimingLabels.call(void 0, s.StartedAt, s.EndedAt)
                const roomUsersCount = s.RoomUsers ? s.RoomUsers.length : 0
                const roomUsersLabel = roomUsersCount === 1
                  ? '1 participant'
                  : `${roomUsersCount} participants`

                return (
                    _react2.default.createElement('div', {
                      key: s.RoomSessionKey,
                      onClick: () => onSessionPick(s.RoomSessionKey),
                      className: "meeting--table-row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 166}}

                      , _react2.default.createElement('div', { className: "meeting--table-col start-col" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 171}}, startedAt)
                      , _react2.default.createElement('div', { className: "meeting--table-col participants-col" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 172}}, roomUsersLabel)
                      , _react2.default.createElement('div', { className: "meeting--table-col duration-col" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 173}}, duration)
                      , _react2.default.createElement('div', { className: "meeting--table-col more-col" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 174}}, "Details")
                    )
                )
              })
              
            )
            , _react2.default.createElement('div', { className: "meeting-room--history-paging", __self: this, __source: {fileName: _jsxFileName, lineNumber: 180}}
              , _react2.default.createElement('div', { className: "meeting-room--history-paging--nav", __self: this, __source: {fileName: _jsxFileName, lineNumber: 181}}
                , _react2.default.createElement('div', {
                  onClick: gotoPrevPage,
                  className: "meeting-room--history-paging--arrow prev" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 182}}
                )
                , 
                  Array(listedPagesCount).fill(0).map((_, i) => {
                    const idx = _utils.clamp.call(void 0, 
                      0, pagesCount - (listedPagesCount - i),
                    )(currentPage + i)

                    return (
                      _react2.default.createElement('span', {
                        key: idx,
                        onClick: () => gotoPage(idx),
                        className: _classBuilder2.default.call(void 0, 
                          "meeting-room--history-paging--page-idx",
                          idx === currentPage && 'active',
                        ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 193}}

                        ,  idx + 1 
                      )
                    )
                  })
                
                , _react2.default.createElement('div', {
                  onClick: gotoNextPage,
                  className: "meeting-room--history-paging--arrow next" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 206}}
                )
                , _react2.default.createElement('span', { className: "metting-room--history-paging--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 210}}
                  ,  pageMinIdx , " - "  ,  pageMaxIdx , " out of "   ,  totalSessionsCount , " sessions"
                )
              )
            )
          )
          )
      
    )
  )
}

exports. default = DesktopHistoryList
